export const getCommitmentStatementMixin = {
  methods: {
    downloadCommitmentStatement () {
      this.busyCommitmentStatement = true
      let host = ''
      switch (this.$parent.userInfo.piportals[0].alias) {
        case 'afb':
          host = 'app.fill-bill.ru'
          break
        case 'pi':
          host = 'fill-bill.prominvest.ru'
          break
        case 'bs':
          host = 'blacksea.fill-bill.ru'
          break
        case 'afbpp':
          host = 'app-predprod.ctm'
          break
        default:
          break
      }
      const report4emptycont = {
        host: host,
        packageId: this.$parent.commitmentStatementRow.item.pid
      }
      this.getReport4emptycont_new(report4emptycont).then(
        (document) => {
          if (document.length === 0) {
            this.$bvToast.toast('Отсутствуют данные по порожним контейнерам', {
              title: 'Невозможно выгрузить ЗО',
              variant: 'danger',
              name: 'b-toaster-top-center'
            })
            this.reportDatePickerValue1 = this.moment(new Date()).format('YYYY-MM-DD')
            this.reportDatePickerValue2 = this.moment(new Date()).add(6, 'months').format('YYYY-MM-DD')
            this.busyCommitmentStatement = false
            return
          }
          try {
            let doc = null
            if (window.DOMParser) {
              const totalPages = []
              const templateHeader = '<html><head><style>' +
                'body { line-height: 1.5; }\n' +
                'div.page { font-size: 10pt; font-weight: normal; margin: 55px 37px 0px 55px; position: relative; height: 1067px; }\n' + // 1023
                '</style></head><body>' +
                '<div class="page"><div id="template-header">' +
                '<div style="margin-bottom: 30px;"><img style="height: 30px;" src="/account/containerships.png" /></div>\n' +
                '<div>\n' +
                '  <table style="width: 100%">\n' +
                '\t<tbody>\n' +
                '\t  <tr>\n' +
                '\t\t<td style="width: 50%; vertical-align: top;">\n' +
                '\t\t  <div style="float: left">' +
                this.moment(this.reportDatePickerValue1).format('LL') +
                '</div>\n' +
                '\t\t</td>\n' +
                '\t\t<td style="width: 50%; text-align: right; vertical-align: top;"><span>Балтийская таможня</span><br><span>т/п Бронка</span></td>\n' +
                '\t  </tr>\n' +
                '\t</tbody>\n' +
                '  </table>\n' +
                '<div style="text-align: center; margin-bottom: 5px;"><b>Заявление-обязательство о временном ввозе товаров</b></div>' +
                '<div style="margin-bottom: 5px; display: flex; justify-content: center; align-items: center;"><div>53/10216160/</div><div>' +
                this.moment(this.reportDatePickerValue1).format('DDMMYY') +
                '</div><div>/ЗО0____________</div></div>' +
                '</div>' +
                '<div style="width: 100%;">Просим Вас разрешить временный ввоз порожних контейнеров, указанных в <i>табл. №1</i> на территорию Таможенного союза, в соответствии с Приложением В.3. к Конвенции о временном ввозе от 26.06.1990 года, с полным освобождением от уплаты таможенных платежей.</div>' +
                '<div style="margin-bottom: 5px; font-size: 13px; font-style: italic; text-align: right;">Таблица №1</div></div>'

              const runningTitleHeader = '<html><head><style>' +
                'body { line-height: 1.5; }\n' +
                'div.page { font-size: 10pt; font-weight: normal; margin: 55px 37px 0px 55px; position: relative; height: 1067px; }\n' +
                '</style></head><body>' +
                '<div class="page">' +
                '<div style="margin-bottom: 30px;"><img style="height: 30px;" src="/account/containerships.png" /></div>'

              const templateFooter = '<div id="template-footer" style="margin-top: 5px;"><div>Настоящим АО «Контейнершипс Санкт-Петербург» обязуется перед т/п Бронка Балтийской таможни возвратить</div>\n' +
                '<div style="display: flex; justify-content: start; align-items: center;">\n' +
                '\t<div style="margin-right: 8px;">товары, указанные в <i>табл.№1</i> в неизменном состоянии в срок до</div>\n' +
                '\t<div style="margin-right: 8px; font-weight: bold;">' + this.moment(this.reportDatePickerValue2).format('DD/MM/YYYY') + '</div>\n' +
                '\t<div>г.</div>\n' +
                '</div>\n' +
                '<div>\n' +
                '\t<div style="margin-bottom: 5px;">Контейнеры принадлежат Containerships - CMA-CGM GmbH.</div>\n' +
                '\t<div style="margin-bottom: 5px;">Об ответственности, установленной КоАП РФ за несоблюдение таможенной процедуры временного ввоза АО «Контейнершипс Санкт-Петербург» предупрежден.</div>\n' +
                '\t<div style="margin-bottom: 5px;">' + this.reportSignatureText + '</div>\n' +
                '<div>\n' +
                '            Отметка должностного лица таможенного органа_________________________________________<br>\n' +
                '            Товар соответствует заявленным сведениям\n' +
                '          </div>' +
                '</div></div>'

              const runningTitleFooter = '<div style="position: absolute; bottom: 55px; text-align: left">\n' +
                '\t<img style="height: 24px;" src="/account/cma_cgm.png" />\n' +
                '\t<div style="font-size: 8px; margin-top: 3px;">АО "Контейнершипс Санкт-Петербург"</div>\n' +
                '\t<div style="font-size: 8px;">Адрес (место нахождения, почтовый): 197227, Санкт-Петербург, вн.тер.г. Муниципальный Округ № 65, ул. Савушкина, д. 126 лит. А, помещ. 164-Н, офис 224</div>\n' +
                '\t<div style="font-size: 8px;">Tel: +7 (812) 324 46 36</div>\n' +
                '\t<div style="font-size: 8px;">ОГРН 1037811038210 ИНН 7805013196</div>\n' +
                '\t<div style="font-size: 8px;">www.containershipsgroup.com</div>\n' +
                '</div>' +
                '<div style="position: absolute; bottom: 35px; width: calc(50% + 38px); height: 10px; right: -38px; background-color: #ed1c24;">\n' +
                '</div>' +
                '</div></body></html>'

              const parser = new DOMParser()
              doc = parser.parseFromString(document, 'text/html')
              let vesselName = ''
              let cruise = ''
              if (doc.documentElement.getElementsByTagName('vesselname').length > 0) { // судно
                vesselName = doc.documentElement.getElementsByTagName('vesselname')[0].innerHTML
              }
              if (doc.documentElement.getElementsByTagName('cruise').length > 0) { // рейс
                cruise = doc.documentElement.getElementsByTagName('cruise')[0].innerHTML
              }
              const conosaments = doc.documentElement.getElementsByTagName('conosament')
              let chunk = ''
              for (let i = 0; i < conosaments.length; i++) {
                chunk += '<table class="currentElem"  style="width: 100%; border: 1px solid black;">\n' +
                  '\t\t<thead>\n' +
                  '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">№<br> п/п</th>\n' +
                  '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Наименование</th>\n' +
                  '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Кол-во,<br> шт.</th>\n' +
                  '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Вес, кг</th>\n' +
                  '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Стоимость,<br> евро</th>\n' +
                  '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Коносамент</th>\n' +
                  '\t\t\t<th style="padding: 5px; text-align: center;">Судно</th>\n' +
                  '\t\t</thead><tbody>'
                const conosamentNum = conosaments[i].getElementsByTagName('conosamentnum')[0].innerHTML
                const tare = conosaments[i].getElementsByTagName('tare')[0].innerHTML
                const cost = conosaments[i].getElementsByTagName('cost')[0].innerHTML
                const countContainer = conosaments[i].getElementsByTagName('countcontainer')[0].innerHTML
                const containers = conosaments[i].getElementsByTagName('container')
                chunk += '<tr>' +
                  '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black;">&nbsp;</td>' +
                  '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">Контейнеры, предназначенные для перевозки одним или несколькими видами транспорта:</td>' +
                  '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + countContainer + '</td>' +
                  '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + tare + '</td>' +
                  '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + cost + '</td>' +
                  '<td rowspan="' + (containers.length + 1) + '" style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + conosamentNum + '</td>' +
                  '<td rowspan="' + (containers.length + 1) + '" style="padding: 5px; border-top: 1px solid black; text-align: center; font-weight: bold">' + vesselName + ', ' + cruise + '</td></tr>'
                for (let j = 0; j < containers.length; j++) {
                  const containerNum = containers[j].getElementsByTagName('containernum')[0].innerHTML
                  const containerTare = containers[j].getElementsByTagName('containertare')[0].innerHTML
                  const containerCost = containers[j].getElementsByTagName('containercost')[0].innerHTML
                  const containerCount = containers[j].getElementsByTagName('containercount')[0].innerHTML
                  chunk += '<tr>' +
                    '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black;">' + (j + 1) + '</td>' +
                    '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center;">' + containerNum + '</td>' +
                    '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center;">' + containerCount + '</td>' +
                    '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center;">' + containerTare + '</td>' +
                    '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center;">' + containerCost + '</td></tr>'
                  if ((containers.length <= 10) && (j === (containers.length - 1))) {
                    chunk += '</tbody></table>'
                    totalPages.push(templateHeader + chunk + templateFooter + runningTitleFooter)
                    chunk = '<table class="currentElem"  style="width: 100%; border: 1px solid black;">\n' +
                      '\t\t<thead>\n' +
                      '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">№<br> п/п</th>\n' +
                      '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Наименование</th>\n' +
                      '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Кол-во,<br> шт.</th>\n' +
                      '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Вес, кг</th>\n' +
                      '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Стоимость,<br> евро</th>\n' +
                      '\t\t\t<th style="padding: 5px; border-right: 1px solid black; text-align: center;">Коносамент</th>\n' +
                      '\t\t\t<th style="padding: 5px; text-align: center;">Судно</th>\n' +
                      '\t\t</thead>'
                  }
                  if (containers.length > 10 && containers.length < 12 && (((j + 1) % 11) === 0)) {
                    chunk += '</tbody></table>'
                    totalPages.push(templateHeader + chunk + runningTitleFooter)
                    totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                  }
                  if (containers.length > 10 && containers.length < 13 && (((j + 1) % 12) === 0)) {
                    chunk += '</tbody></table>'
                    totalPages.push(templateHeader + chunk + runningTitleFooter)
                    totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                  }
                  if (containers.length > 10 && containers.length < 14 && (((j + 1) % 13) === 0)) {
                    chunk += '</tbody></table>'
                    totalPages.push(templateHeader + chunk + runningTitleFooter)
                    totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                  }
                  if (containers.length > 10 && containers.length < 15 && (((j + 1) % 14) === 0)) {
                    chunk += '</tbody></table>'
                    totalPages.push(templateHeader + chunk + runningTitleFooter)
                    totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                  }
                  if (containers.length > 10 && (((j + 1) % 15) === 0) && (j === 14)) {
                    chunk += '</tbody></table>'
                    totalPages.push(templateHeader + chunk + runningTitleFooter)
                    chunk = '<table class="currentElem"  style="width: 100%; border: 1px solid black;"><tbody>'
                    chunk += '<tr>' +
                      '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black;">&nbsp;</td>' +
                      '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">Контейнеры, предназначенные для перевозки одним или несколькими видами транспорта:</td>' +
                      '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + countContainer + '</td>' +
                      '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + tare + '</td>' +
                      '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + cost + '</td>' +
                      '<td rowspan="' + (containers.length + 1) + '" style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold"><span>' + conosamentNum + '</span></td>' +
                      '<td rowspan="' + (containers.length + 1) + '" style="padding: 5px; border-top: 1px solid black; text-align: center; font-weight: bold"><span>' + vesselName + ', ' + cruise + '</span></td></tr>'
                    if (containers.length === 15) {
                      totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                    }
                  }
                  if ((containers.length > 15) && (j > 14) && (((j - 14) % 25) === 0)) {
                    chunk += '</tbody></table>'
                    totalPages.push(runningTitleHeader + chunk + runningTitleFooter)
                    if ((j + 1) < containers.length) {
                      chunk = '<table class="currentElem"  style="width: 100%; border: 1px solid black;"><tbody>'
                      chunk += '<tr>' +
                        '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black;">&nbsp;</td>' +
                        '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">Контейнеры, предназначенные для перевозки одним или несколькими видами транспорта:</td>' +
                        '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + countContainer + '</td>' +
                        '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + tare + '</td>' +
                        '<td style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold">' + cost + '</td>' +
                        '<td rowspan="' + (containers.length + 1) + '" style="padding: 5px; border-right: 1px solid black; border-top: 1px solid black; text-align: center; font-weight: bold"><span>' + conosamentNum + '</span></td>' +
                        '<td rowspan="' + (containers.length + 1) + '" style="padding: 5px; border-top: 1px solid black; text-align: center; font-weight: bold"><span>' + vesselName + ', ' + cruise + '</span></td></tr>'
                    } else {
                      chunk = ''
                    }
                  }
                  if ((containers.length > 15) && ((containers.length - j) <= 10) && (j === (containers.length - 1))) {
                    chunk += '</tbody></table>'
                    if (totalPages.length === 1) {
                      if ((j - (14 * totalPages.length)) > 20) {
                        totalPages.push(runningTitleHeader + chunk + runningTitleFooter)
                        totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                      } else {
                        totalPages.push(runningTitleHeader + chunk + templateFooter + runningTitleFooter)
                      }
                    } else if (totalPages.length > 1) {
                      if ((j - (14 + (24 * (totalPages.length - 1)))) > 20) {
                        totalPages.push(runningTitleHeader + chunk + runningTitleFooter)
                        totalPages.push(runningTitleHeader + templateFooter + runningTitleFooter)
                      } else {
                        totalPages.push(runningTitleHeader + chunk + templateFooter + runningTitleFooter)
                      }
                    }
                  }
                }
                chunk = ''
              }
              const pdfOptions = {
                margin: 0,
                filename: this.$parent.commitmentStatementRow.item.pid + '_Commitment_Statement.pdf',
                image: { type: 'jpeg', quality: 0.96 },
                html2canvas: { scale: 2, width: 794, scrollY: 0, scrollX: 0 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
              }
              this.downloadPDFCommitmentStatement(totalPages, pdfOptions)
            }
          } catch (e) {
            this.busyCommitmentStatement = false
            throw new Error('Ошибка при обработке документа html. ' + (e.message || e))
          }
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }
}
